import React, {Component} from "react";
import {withStyles} from "@material-ui/core/styles/index";
import {connect} from "react-redux";
import {compose} from "recompose";
import { BarLoader } from 'react-spinners'
import {Chart} from "react-google-charts";

const styles = theme => ({
	loader: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center"
	}
});

class LineChart extends Component {

	render() {
		const { rows,columns } = this.props

		return <Chart
			width={'100%'}
			height={'200px'}
			chartType="LineChart"
			loader={<div>
				<BarLoader
					color="#a71c21"
					margin="5px" />
			</div>}
			rows={rows}
			columns={columns}

			options={{
				title: null,
				sliceVisibilityThreshold: 0.05,
				pieStartAngle: 180,
				slices: [
					{
						color: "#F47A1F"
					},
					{
						color: "#FDBB2F"
					},
					{
						color: "#377B2B"
					},
					{
						color: "#7AC142"
					},
					{
						color: "#007CC3"
					},
					{
						color: "#00529B"
					}
				],
				legend: {
					position: "bottom",
					alignment: "center",
					textStyle: {
						color: "233238",
						fontSize: 14
					}
				},
                annotations: {
                    style: 'point'
                }
			}}
			rootProps={{ 'data-testid': '2' }}
		/>
	}
}

const mapStateToProps = function(storage) {
	return {
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
	}
}

export default compose(
	connect(
		mapStateToProps,
		mapDispatchToProps,
	),
	withStyles(styles)
)(LineChart)
